export { default } from './FollowUpQuestions.component';
